import { all } from "redux-saga/effects";
import authSaga from "../features/Auth/slices/authSaga";
import shopSaga from "../features/Shop/slices/shopSaga";

function* rootSaga() {
  yield all([authSaga(), shopSaga()]);
}

export default rootSaga;
